// Example: 5월 23일 목요일 저녁 7시
export const formatReservationTime = (
  isoString: string,
  {
    includeDate = true,
    includeTime = true,
    includeWeekday = true,
  }: {
    includeDate?: boolean;
    includeTime?: boolean;
    includeWeekday?: boolean;
  } = {}
) => {
  if (!isoString) return "날짜 정보 없음";
  try {
    const date = new Date(isoString);
    const timeZone = "Asia/Seoul";

    // Format date part in Korea timezone
    const datePart = date.toLocaleDateString("ko-KR", {
      timeZone,
      month: "long",
      day: "numeric",
      weekday: includeWeekday ? "long" : undefined,
    });

    // Get hour in Korea timezone
    const koreaHour = parseInt(
      date.toLocaleString("ko-KR", {
        timeZone,
        hour: "numeric",
        hour12: false,
      })
    );

    const period = koreaHour >= 18 ? "저녁" : koreaHour >= 12 ? "오후" : "오전";

    let displayHour = koreaHour;
    if (displayHour > 12) {
      displayHour -= 12;
    }
    if (displayHour === 0) {
      displayHour = 12;
    }

    return `${includeDate ? datePart : ""} ${includeTime ? period : ""} ${
      includeTime ? displayHour + "시" : ""
    }`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "날짜 형식 오류";
  }
};

// Example: 5월 23일
export const formatDateToMonthDay = (isoString: string) => {
  if (!isoString) return "날짜 정보 없음";
  try {
    const date = new Date(isoString);
    return date.toLocaleDateString("ko-KR", {
      timeZone: "Asia/Seoul",
      month: "long",
      day: "numeric",
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "날짜 형식 오류";
  }
};

// Example: 2025년 5월
export const formatDateToYearMonth = (isoString: string) => {
  if (!isoString) return "날짜 정보 없음";
  try {
    const date = new Date(isoString);
    return date.toLocaleDateString("ko-KR", {
      timeZone: "Asia/Seoul",
      year: "numeric",
      month: "long",
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "날짜 형식 오류";
  }
};

export const calculateAge = (birthDateString: string | null | undefined) => {
  if (!birthDateString) return null;
  const birthDate = new Date(birthDateString);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// Convert ISO date string or Date object to YYYY-MM-DD format
// Example: "1992-12-12T00:00:00.000Z" -> "1992-12-12"
export const formatDateToYYYYMMDD = (date: string | Date | null | undefined): string => {
  if (!date) return "";
  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    // Use UTC methods to avoid timezone issues
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error formatting date to YYYY-MM-DD:", error);
    return "";
  }
};
